export default __webpack_public_path__ + "static/media/uncertainty.ab45b060.svg";